import { ComponentPublicInstance, onMounted, onUnmounted, ref } from "vue";
import { injectRuntimeConfig } from "./runtimeConfig";

interface FormInput {
  type: string;
  get: () => string;
  set: (value: string) => void;
}

export function composePopoverForm(title: string, inputs: FormInput[]) {
  const rc = injectRuntimeConfig();
  const elementRef = ref<HTMLElement | ComponentPublicInstance | undefined>();
  const localElRef = ref<HTMLElement | undefined>();

  function hoverCallback(event: Event) {
    event.stopPropagation();
    rc.value.globalEmit?.("brandHover", {
      title,
      inputs,
      el: localElRef.value
    });
  }

  function clickCallback(event: Event) {
    event.preventDefault();
    rc.value.globalEmit?.("brandClick", {
      title,
      inputs,
      el: localElRef.value
    });
  }

  onMounted(() => {
    localElRef.value = (elementRef.value as ComponentPublicInstance)?.$el
      ? (elementRef.value as ComponentPublicInstance)?.$el
      : elementRef.value;

    if (localElRef.value && rc.value.globalEmit) {
      localElRef.value.addEventListener("click", clickCallback);
      localElRef.value.addEventListener("mouseover", hoverCallback);
      localElRef.value.style.cursor = "pointer";
    }
  });

  onUnmounted(() => {
    if (localElRef.value) {
      localElRef.value.style.cursor = "";
      localElRef.value.removeEventListener("click", clickCallback);
      localElRef.value.removeEventListener("mouseover", hoverCallback);
    }
  });

  return {
    targetEl: elementRef
  };
}
